// extracted by mini-css-extract-plugin
export var cta = "index-module--cta--3f5XG";
export var ctaBlock = "index-module--ctaBlock--xML3j";
export var ctaOnlyBlock = "index-module--ctaOnlyBlock--Wam5f";
export var desktopCtaBlockWrapper = "index-module--desktopCtaBlockWrapper--fdaUJ";
export var details = "index-module--details--1r8KA";
export var divider = "index-module--divider--maHjF";
export var image = "index-module--image--tAZ6u";
export var productCta = "index-module--productCta--sGMpj";
export var productDetail = "index-module--productDetail--0tCeR";
export var productDetailsContainer = "index-module--productDetailsContainer--mtq+O";
export var productDetailsInfo = "index-module--productDetailsInfo--0j5aE";
export var productDetailsWrapper = "index-module--productDetailsWrapper---Q0yU";
export var threeProductDetails = "index-module--threeProductDetails--jwHF3";